import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _SignOutCircleLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "M8 18.928A8 8 0 1 0 8 5.072" }),
            React.createElement("path", { fill: "currentColor", d: "m2 12-.39-.312-.25.312.25.312zm9 .5a.5.5 0 0 0 0-1zM5.61 6.688l-4 5 .78.624 4-5zm-4 5.624 4 5 .78-.624-4-5zM2 12.5h9v-1H2z" })));
}
const SignOutCircleLight = forwardRef(_SignOutCircleLight);
export { SignOutCircleLight };
